import axios from 'axios';

const SettingApi = {};

const nonce = devsAccountingApi.nonce;

SettingApi.index = async (params = null) => {
    const url = '/wp-json/devs-accounting/v1/settings/';
    try {
        const response = await axios.get(url, { params: params });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

SettingApi.show = async (id, params = null) => {
    const url = '/wp-json/devs-accounting/v1/show-setting/' + id;
    try {
        const response = await axios.get(url, { params: params });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

SettingApi.delete = async (id, params = null) => {
    const url = '/wp-json/devs-accounting/v1/delete-setting/' + id;
    try {
        const response = await axios.get(url, {
            headers: {
                'X-WP-Nonce': nonce
            }
        });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

SettingApi.save = async (data) => {
    let url = "/wp-json/devs-accounting/v1/add-setting/";
    const res = await axios.post(url, data, {
        headers: {
            'X-WP-Nonce': nonce
        }
    }).then(response => {
        return response.data;
    }).catch(error => { return []; });
    return res;
}

SettingApi.page = async (params = null) => {
    const url = '/wp-json/wp/v2/pages';
    try {
        const response = await axios.get(url, { params: params });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

export default SettingApi;